import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import List from "./list";
import ListDetailsSubLayout from "../../layout/ListDetailSubLayout";
import Details from "./details";
import useCommonStore from "../../stores/common";
import useShippingStore from "../../stores/shipping";
import useUserStore from "../../stores/user";
import { loadShippingOfficeOptions } from "../../services/shipping";
import detailsStyles from "./details/styles.module.scss";

const ShippingPage = () => {
  const reset = useShippingStore((state) => state.reset);
  const selectedShipping = useShippingStore((state) => state.selectedShipping);
  const isEntitySuperAdmin = useUserStore((state) => state.isEntitySuperAdmin);

  useEffect(() => {
    loadShippingOfficeOptions();
    return () => {
      useCommonStore.getState().reset();
      reset();
    };
  }, [reset]);

  const mobileHeaderActions =
    isEntitySuperAdmin && selectedShipping?.powerapp_id ? (
      <Link
        to={`/v2/merchants/${selectedShipping.powerapp_id}`}
        className={detailsStyles.to_app_button}
      >
        View Merchant
      </Link>
    ) : null;

  return (
    <ListDetailsSubLayout
      listComponent={List}
      detailsComponent={Details}
      mobileHeaderActions={mobileHeaderActions}
    />
  );
};

export default ShippingPage;
